import { workCodeProxy, configCodeProxy, empCodeProxyBody } from './index';
// proxy/work/code/1.0/

/* [ 코드 ] */
// work코드
function getWorkCommonCode(params) {
  return workCodeProxy.get(`list`, { params });
}

// emp코드
function getEmpCommonCode(params) {
  return empCodeProxyBody.post(`lists`, params);
}

function getCommonCode(params) {
  return configCodeProxy.get('lists', { params });
}

export { getWorkCommonCode, getEmpCommonCode, getCommonCode };
